import { ConditionType } from '@/types/cml-api'

export const convertToMilliseconds = (time: number, unit: ConditionType): number => {
    switch (unit) {
        case ConditionType.Second:
            return time * 1000
        case ConditionType.Minute:
            return time * 1000 * 60
        case ConditionType.Hour:
            return time * 1000 * 60 * 60
        default:
            return time
    }
}
